import { render, staticRenderFns } from "./delivery-address-form.vue?vue&type=template&id=60639ce7&scoped=true&"
import script from "./delivery-address-form.vue?vue&type=script&lang=js&"
export * from "./delivery-address-form.vue?vue&type=script&lang=js&"
import style0 from "./delivery-address-form.vue?vue&type=style&index=0&id=60639ce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60639ce7",
  null
  
)

export default component.exports